import { merge } from "lodash-es";
import { useMemo } from "react";

import { ScheduleHelper } from "@/common/helpers/schedule";
import { ScheduleEntryDto } from "@/core/api/generated/v1";

import { BaseEntityInlineInheritableProps } from "../Entity/components/EntityInline/BaseEntityInline";
import EntityInline from "../Entity/components/EntityInline/EntityInline";

interface Props {
  entry: ScheduleEntryDto;
  inlineProps?: Partial<BaseEntityInlineInheritableProps>;
}

// Redefine inline title here to make it shorter in this scope
export function ScheduleEntrySourceEntityInline({ entry, inlineProps }: Props) {
  const inlinePropsComputed = useMemo(
    () =>
      merge(
        {},
        {
          withIcon: true,
          withTooltip: true,
          tooltipProps: { enterDelay: 300, enterNextDelay: 300 },
          displayProps: {
            // hide extra info in title
            vehicle: false,
            contract: false,
            customer: false,
          },
        } satisfies BaseEntityInlineInheritableProps,
        inlineProps,
      ),
    [inlineProps],
  );

  const sourceEntityDto = useMemo(
    () => ScheduleHelper.getFullSourceEntityFromEntry(entry),
    [entry],
  );
  if (!sourceEntityDto) {
    return null;
  }

  return (
    <EntityInline
      entityType={entry.sourceEntity?.entity?.entityType}
      entityId={sourceEntityDto.id}
      entity={sourceEntityDto}
      inlineProps={inlinePropsComputed}
    />
  );
}
